// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getBoostBidsForProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetBoostBidProfessionalApi = createAsyncThunk(
  "hitGetBoostBidProfessionalApi",
  async (jobId = "") => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: {
          jobId: jobId,
        },
      };
      const url = ApiBaseUrl + getBoostBidsForProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetBoostBidProfessionalSlice = createSlice({
  name: "getBoostBidProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetBoostBidData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetBoostBidProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetBoostBidProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetBoostBidProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetBoostBidData } = GetBoostBidProfessionalSlice.actions;
export default GetBoostBidProfessionalSlice.reducer;
